import React, { Component } from "react";
import { Tooltip } from 'antd';
import  PropTypes from 'prop-types';
import moment from 'moment';
import { withRouter } from "react-router";
import Buttons from "./Buttons";
import PoolInfoModal from "./PoolInfoModal/FundModal";
import PopUp from "./PopUp";
import TiffAllPoolTable from "./TiffAllPoolTable";
import FlowCard from "../../../../../CommonComponents/FlowCard/FlowCard";
import TitleNode from "../../../../../CommonComponents/CustomNodes/TitleNode/TitleNode";
import Preloader from "../../../../../CommonComponents/Preloader/Preloader";
import { DataHeading } from "../../../../../CommonComponents/commonStyles";
import PercentageInput from "../../../../../CommonComponents/PercentageInput/PercentageInput";
import { initiateTracking } from "../../../../../utils/commonUtil";
import { milliToDate, recordError } from '../../../../../utils/commonUtil';
import {
  Title,
  DesktopView,
  MobileView,
  PoolName,
  DescriptionTo,
  AmountInfo,
  TotalDollarAmount,
  FooterWrapper,
  DollarAmount,
  ResetAll,
  Divider,
  PoolCategory,
  UnderlyingContent
} from "./styles";
import {
  dollarText,
  unitText,
  pricePerUnitText,
  replaceSelect
} from "../../../../../utils/replacer";
import {
  startDate,
  todayDate
} from "../../../../../utils/commonUtil";
import {
  getPrimaryAccount,
  getAccountData
} from "../../../../../utils/sessionUtil";
class TIFFRecommendAnExchangestep2 extends Component {
  state = {
    setKeys: false,
    poolData: [],
    exchangeFromPool: {},
    totalFromPools: 0,
    poolCount: 0,
    exitPopUp: false,
    amountFrom: 0,
    isEditEnable: true,
    step2Error: false
  };

  componentDidMount() {
    this.props.requestAllPoolDataTiff([{
      payload: {
        method: "GET",
        page: "recommendAnExchange",
        url: `/donor-portal/api/investment/${
          getPrimaryAccount().userId
          }/findInvestmentPoolOptionsByAccountIdStartDateAndEndDate?startDateStr=${startDate(
            7
          )}&endDateStr=${todayDate()}`
      }
    }, {
      payload: {
        method: "GET",
        page: "recommendAnExchange",
        url: `/donor-portal/api/investmentOptions/findInvestmentOptionsByAccountIdFromDateAndToDate?accountId=${
          getPrimaryAccount().userId
          }&fromDate=${startDate(7)}&toDate=${todayDate()}`
      }
    }]);

    if (this.props.stepTwoSet) {
      this.setState((prevState, props) => {
        let exchangeFromPool = this.props.stepTwoData.inputValue;
        let totalFromPools = this.props.stepTwoData.totalFromPools;
        let data = this.props.allPoolFromData;
        let newArr = data.filter(
          item => item.poolName !== "TIFF Multi-Asset Pool"
        );
        return {
          exchangeFromPool: exchangeFromPool,
          totalFromPools: totalFromPools,
          setKeys: true,
          poolData: newArr,
          amountFrom: this.props.stepOneData.valueTiffExchangeAmount
        };
      });
    }
    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.allPoolFromLoading &&
      !this.state.setKeys &&
      !nextProps.stepTwoSet
    ) {
      this.setState((prevState, props) => {
        const { exchangeFromPool } = prevState;
        var newData = [];

        if (nextProps.allPoolFromData) {
          newData = nextProps.allPoolFromData.filter((item) => {
            if (item.poolName === "TIFF Multi-Asset Pool") {
              return false;
            } else {
              exchangeFromPool[item.poolId] = "";
              return true;
            };
          });
        }

        if (nextProps.isDisabled) {
          var totalPercent = 0;
          var newData = nextProps.allPoolData && nextProps.allPoolData.filter(
            item => item.poolName !== "TIFF Multi-Asset Pool"
          );
          nextProps.getTiffDetails.exchangeTo.map(data => {
            for (var key in exchangeFromPool) {
              if (Number(key) === Number(data.poolId)) {
                exchangeFromPool[Number(key)] = data.percentage;
                totalPercent += Number(data.percentage);
              }
            }
          });
          return {
            setKeys: true,
            exchangeFromPool: exchangeFromPool,
            totalFromPools: totalPercent,
            poolData: newData,
            amountFrom: nextProps.exchangeAmount
          };
        }
        return { exchangeFromPool: exchangeFromPool, setKeys: true, poolData: newData, amountFrom: this.props.stepOneData.valueTiffExchangeAmount };
      });
    }
  }

  setInputValues = value => {
    const exchangeFromPool = JSON.parse(JSON.stringify(this.state.exchangeFromPool))
    var isEnable = '';
    if (value.value <= 100) {
      exchangeFromPool[value.key] = value.value;
      this.setState({ exchangeFromPool });
      let total = 0;
      let count = 0;
      Object.keys(exchangeFromPool).forEach(key => {
        if (exchangeFromPool[key] !== "") {
          const add = parseFloat(exchangeFromPool[key]).toFixed(2);
          total = Number(total) + Number(add);
          count++;
        }
      });
      if (total === 100) {
        isEnable = false;
      }
      else isEnable = true;
      this.setState({ totalFromPools: total, poolCount: count, isEditEnable: isEnable });
    }
  };

  nextStep2Validation = () => {
    const {totalFromPools, isEnable} = this.state;
    if(this.props.history.location.params){
      if(!this.enableUpdate() && !isEnable) {          
          return true
        } else {
          this.setState({step2Error: true})
          return false
        }
    } else {
      if(totalFromPools !== 100){
        this.setState({step2Error: true})
        return false
      } else {
        return true
      }
    }
  }

  nextSubmit = () => {
    if(this.nextStep2Validation()){
      initiateTracking('update', 'Recommend an Exchange', "Step 2 Recommend exchange to", "Update - TIFF Exchange FROM");
      const poolEntered = [];
      this.props.allPoolFromData.map(obj => {
        for (let key in this.state.exchangeFromPool) {
          if (this.state.exchangeFromPool.hasOwnProperty(key)) {
            if (
              obj.poolId === Number(key) &&
              this.state.exchangeFromPool[key] != "" &&
              parseInt(this.state.exchangeFromPool[key]) !== 0
            ) {
              const poolObj = {
                poolId: obj.poolId,
                poolName: obj.poolName,
                poolCategory: obj.poolCategory,
                pricePerUnit: obj.pricePerUnit,
                availableBalance: obj.availableBalance,
                availableUnits: obj.availableUnits,
                isRise: obj.isRise,
                value: this.state.exchangeFromPool[key],
                dateOfPricePerUnit: obj.dateOfPricePerUnit,
                asOfDate: obj.asOfDate
              };
              poolEntered.push(poolObj);
            }
          }
        }
      });
      this.props.setStepTwo({
        exchangeFromPoolData: poolEntered,
        inputValue: this.state.exchangeFromPool,
        totalFromPools: this.state.totalFromPools,
        poolCount: this.state.poolCount
      });
      this.props.history.push("/investments/recommend-an-exchange-tiff/review");
    }
  };

  onPoolNameClicked = value => {
    let poolName = value.substring(0, value.lastIndexOf(" "));
    this.props.requestPoolData({
      method: "GET",
      page: "recommendAnExchange",
      url: `/investment-api-funds?poolname=${poolName}`,
      isExternal: true
    });
    this.props.requestunderlyingFunds({
      method: "GET",
      page: "recommendAnExchange",
      url: `/investment-underlying-funds-api?poolname=${poolName}`,
      isExternal: true
    });
  };

  renderTitleGrid = pool => {    
    return (
      <PoolName
        data-test="renderTitle"
        onClick={() => {
          try {
            this.onPoolNameClicked(pool.poolName)
          } catch (error) {
            recordError(error);
          }
        }}
      >
        {replaceSelect(pool.poolName)}
      </PoolName>
    );
  };
  renderFixGrid = ({ pool, gridName }) => {
    const perUpdatedOn = 'Price updated on ' + milliToDate(pool.dateOfPricePerUnit);
    const perUpdatedAsOf = 'Price updated on ' + milliToDate(pool.asOfDate);
    return (
      <>
        <TitleNode title={gridName} />
        {gridName === "availableBalance" && <DataHeading>{dollarText(pool[gridName])}</DataHeading>}
        {gridName === "availableUnits" && <DataHeading>{unitText(pool[gridName])}</DataHeading>}
        {gridName === "pricePerUnit" &&
          <Tooltip placement="bottomLeft" title={pool.availableBalance ? perUpdatedOn : perUpdatedAsOf}>
            <UnderlyingContent>
              {pricePerUnitText(pool[gridName], pool.isRise)}
            </UnderlyingContent>
          </Tooltip>
        }
      </>
    );
  };
  renderInputBox = ({ pool, gridName }) => {
    return (
      <>
        <div>
          <TitleNode title={gridName} />
          <PercentageInput
            onChange={e => {
              const { value } = e.target;
              this.setInputValues({
                key: pool.poolId,
                value: value
              });
              return true;
            }}
            value={this.state.exchangeFromPool[pool.poolId]}
          />
        </div>
      </>
    );
  };

  styleConfig = () => {
    return {
      alternatingBg: true,
      cardBorder: false,
      cardDivider: true,
      cardPadding: true,
      marginBottom: false
    };
  };
  destObj = (pool, index) => {
    return [
      {
        name: "poolName",
        gridWidth: "100",
        type: "TitleGrid",
        render: this.renderTitleGrid(pool),
        noBorderBottom: true,
        ptop: true
      },
      {
        name: "availableBalance",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderFixGrid({ pool, gridName: "availableBalance" }),
        ptop: true,
        pbottom: true
      },
      {
        name: "pricePerUnit",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderFixGrid({ pool, gridName: "pricePerUnit" }),
        ptop: true,
        pbottom: true
      },
      {
        name: "availableUnits",
        gridWidth: "50",
        type: "FixGrid",
        render: this.renderFixGrid({ pool, gridName: "availableUnits" }),
        ptop: true,
        pbottom: true
      },
      {
        name: "Percentage",
        type: "Input",
        gridWidth: "50",
        render: this.renderInputBox({ pool, gridName: "Percentage" }),
        ptop: true,
        pbottom: true
      }
    ];
  };

  filterPools = (investmentPools, poolCategory) => {
    return investmentPools.filter(
      pool => pool.poolCategory === poolCategory.toUpperCase()
    );
  };
  backStepOne = () => {
    initiateTracking('back', 'Recommend an Exchange', 'Step 2 Recommend exchange to', `Back - TIFF Exchange FROM`);
    this.props.history.push("/investments/recommend-an-exchange-tiff");
  };
  cancelOptionModal = () => {
    this.props.setPoolModalFalse(false);
  };
  onExitClick = () => {
    this.setState({ exitPopUp: true });
  };
  exitFlow = () => {
    initiateTracking('exit', 'Recommend an Exchange', 'Step 2 Recommend exchange to', `Exit - TIFF Exchange FROM`);
    this.props.history.push("/investments/recommend-an-exchange-tiff");
    this.props.resetFlow();
    this.setState({ exitPopUp: false });
  };
  stayOnFlow = () => {
    this.setState({ exitPopUp: false });
  };

  clearAll = () => {
    try {
      this.setState((prevState, props) => {
        const { exchangeFromPool } = prevState;
        const { allPoolFromData } = props;
        if (allPoolFromData) {
          allPoolFromData.map(value => {
            exchangeFromPool[value.poolId] = "";
          });
        }
        return { exchangeFromPool: exchangeFromPool, totalFromPools: 0 };
      });
    } catch (error) {
      recordError(error);
    }
  };

  updateStep2Validation = () => {
      if(!this.enableUpdate() && !this.state.isEnable) {
        return true
      } else {
        this.setState({step2Error: true})
        return false
      } 
  }

  update = () => {
    if(this.updateStep2Validation()) {
      initiateTracking('update', 'View and Edit Exchange', "Recommend exchange to", "Update - TIFF Exchange FROM");
      var poolTo = [];
      const { exchangeFromPool } = this.state;
      const { allPoolFromData } = this.props;
      allPoolFromData.map(obj => {
        for (var key in exchangeFromPool) {
          if (exchangeFromPool.hasOwnProperty(key)) {
            if (
              obj.poolId === Number(key) &&
              exchangeFromPool[key] != "" &&
              parseInt(exchangeFromPool[key]) !== 0
            ) {
              const poolObj = {
                poolId: obj.poolId,
                pool: obj.poolName,
                percentage: exchangeFromPool[key]
              };
              poolTo.push(poolObj);
            }
          }
        }
      });
      this.props.submitUpdateTiff({
        method: "PUT",
        url: `/donor-portal/api/exchange/${
          getPrimaryAccount().userId
          }/updateSingleExchange`,
        data: {
          partyId: getAccountData().partyId,
          txnId: this.props.location.params.id,
          startDate: moment(this.props.getTiffDetails.exchangeStartDate).format(
            "YYYY-MM-DD"
          ),
          exchangeType: "Custom Exchange",
          category: "Single Exchange",
          unit: this.props.getTiffDetails.instructionType,
          exchangeFrom: this.props.getTiffDetails.exchangeFrom,
          exchangeTo: poolTo
        },
        selectedTiffOption: this.props.type
      });
    }
  };

  enableUpdate = () => {
    const { stepTwoData } = this.props;
    const { exchangeFromPool, totalFromPools } = this.state;
    var isMatching = (JSON.stringify(stepTwoData.inputValue) === JSON.stringify(exchangeFromPool));
    if (!isMatching) {
      if (totalFromPools !== 100)
        return true;
      else if (totalFromPools === 100) return false;
    }
  }

  render() {
    const { allPoolFromLoading, isDisabled } = this.props;
    const { setKeys, poolData, exchangeFromPool, totalFromPools, isEditEnable, amountFrom } = this.state;
    if (allPoolFromLoading) return <Preloader />;
    return (
      <>
        <Title>Recommend exchange to</Title>
        <DescriptionTo>
          Allocate the following amount into the available investment pools.
        </DescriptionTo>
        <AmountInfo>Amount to be exchanged from TIFF:</AmountInfo>
        <TotalDollarAmount>
          {dollarText(amountFrom)}
        </TotalDollarAmount>

        {setKeys ? (
          <>
            {poolData && poolData.length !== 0 ? <>
              <DesktopView>
                <TiffAllPoolTable
                  data-test="tiffPoolTable"
                  investmentPools={poolData}
                  inputValues={exchangeFromPool}
                  setInputValues={this.setInputValues}
                  totalPercentage={totalFromPools}
                  tiffPoolName={this.props.tiffPoolName}
                  clearAll={this.clearAll}
                  onPoolNameClicked={value => this.onPoolNameClicked(value)}
                />
              </DesktopView>
              <MobileView>
                {[
                  "PORTFOLIO SOLUTIONS",
                  "PORTFOLIO BUILDERS",
                  "VALUES DRIVEN INVESTMENTS"
                ].map(
                  (poolCategory, typeIdx, array) =>
                    !!this.filterPools(poolData, poolCategory)
                      .length && (
                      <>
                        <Divider className="m0" />
                        <PoolCategory>{poolCategory.toLowerCase()}</PoolCategory>
                        {this.filterPools(poolData, poolCategory).map(
                          (pool, index) => (
                            <FlowCard
                              cardConfig={this.destObj(pool, index)}
                              index={index}
                              key={index}
                              styleConfig={this.styleConfig()}
                            />
                          )
                        )}
                      </>
                    )
                )}
                <Divider />
                <FooterWrapper>
                  <DataHeading className="left">Total</DataHeading>
                  <div className="right">
                    <DollarAmount>{totalFromPools}%</DollarAmount>
                    <DataHeading>out of 100%</DataHeading>
                  </div>
                  {totalFromPools !== 0 && <ResetAll className="right mr4" onClick={this.clearAll}>Clear All</ResetAll>}
                </FooterWrapper>
                <Divider />
              </MobileView>
            </> : <Preloader />}
            
            {isDisabled ? (
              <Buttons
                step2Error={this.state.step2Error}
                type={4}
                opacity={"1"}
                width={props => props.theme.buttonWidth.primaryButton}
                onClickUpdate={this.update}
                //disabled={isEditEnable}
                onClickExit={this.onExitClick}
                onClickCancel={() => {
                  initiateTracking('cancel', 'View and Edit Exchange', "Recommend exchange to", "Cancel - TIFF Exchange FROM");
                  this.props.history.push(
                    `/view-edit-tiff-from/${this.props.location.params.id}/edit`
                  );
                }}
              />
            ) : (
                <Buttons
                  type={this.props.history.location.params ? 4 : 2}
                  width={props => props.theme.buttonWidth.primaryButton}
                  onClickNext={this.nextSubmit}
                  onClickUpdate={this.nextSubmit}
                  onClickBack={this.backStepOne}
                  onClickExit={this.onExitClick}
                  step2Error={this.state.step2Error}
                  //disabled={this.props.history.location.params ? (this.enableUpdate() || isEditEnable) : totalFromPools !== 100}
                  onClickCancel={() => {
                    initiateTracking('cancel', 'Recommend an Exchange', "Step 2 Recommend exchange to", "Cancel - TIFF Exchange FROM");
                    this.props.history.push({
                      pathname: `/investments/recommend-an-exchange-tiff/review`
                    });
                  }}
                />
              )}

            <PoolInfoModal
              visible={this.props.poolModal && this.props.modalUF}
              poolUf={this.props.poolUf}
              poolData={this.props.poolDataModal}
              cancelOptionModal={this.cancelOptionModal}
            />
            <PopUp
              type="EXIT"
              visible={this.state.exitPopUp}
              onOk={this.exitFlow}
              onCancel={this.stayOnFlow}
            />
          </>
        ) : (
            <Preloader />
          )}
      </>
    );
  }
}

TIFFRecommendAnExchangestep2.propTypes = {
  requestAllPoolDataTiff: PropTypes.array,
  loading: PropTypes.bool,
  allPoolFromLoading: PropTypes.bool,
  requestPoolData: PropTypes.func,
  setPoolModalFalse: PropTypes.func,
  poolUf: PropTypes.array,
  poolData: PropTypes.array,
  setStepTwo: PropTypes.func,
}

export default withRouter(TIFFRecommendAnExchangestep2);
